<template>
  <span class="automation-source-pill" :class="{ 'automation-source-pill--paused': paused }">
    {{ label }}
  </span>
</template>

<script>
const TOOLKIT_DISPLAY = {
  hubspot: 'HUBSPOT',
  salesforce: 'SALESFORCE',
  stripe: 'STRIPE',
  linear: 'LINEAR',
  notion: 'NOTION',
  github: 'GITHUB',
  slack: 'SLACK',
  zendesk: 'ZENDESK',
  intercom: 'INTERCOM',
  mixpanel: 'MIXPANEL',
  google_analytics: 'GA4',
  google_sheets: 'SHEETS',
  jira: 'JIRA',
}

export default {
  name: 'AutomationSourcePill',
  props: {
    toolkitSlug: { type: String, required: true },
    paused: { type: Boolean, default: false },
  },
  computed: {
    label() {
      const slug = (this.toolkitSlug || '').toLowerCase()
      if (TOOLKIT_DISPLAY[slug]) return TOOLKIT_DISPLAY[slug]
      return slug.replace(/_/g, ' ').toUpperCase() || 'SOURCE'
    },
  },
}
</script>

<style scoped>
.automation-source-pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f2ecfb;
  color: #6c30cc;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 1.4;
}

.automation-source-pill--paused {
  background: #f5f5f5;
  color: #8a8a8a;
}
</style>
